'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _order = require('./order');

var _order2 = _interopRequireDefault(_order);

var _product = require('./product');

var _product2 = _interopRequireDefault(_product);

var _product_type = require('./product_type');

var _product_type2 = _interopRequireDefault(_product_type);

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _user = require('./user');

var _user2 = _interopRequireDefault(_user);

var _level = require('./level');

var _level2 = _interopRequireDefault(_level);

var _finance = require('./finance');

var _finance2 = _interopRequireDefault(_finance);

var _inout = require('./inout');

var _inout2 = _interopRequireDefault(_inout);

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _captcha = require('./captcha');

var _captcha2 = _interopRequireDefault(_captcha);

var _register = require('./register');

var _register2 = _interopRequireDefault(_register);

var _nav = require('./nav');

var _nav2 = _interopRequireDefault(_nav);

var _pickup_station = require('./pickup_station');

var _pickup_station2 = _interopRequireDefault(_pickup_station);

var _shipping_template = require('./shipping_template');

var _shipping_template2 = _interopRequireDefault(_shipping_template);

var _media = require('./media');

var _media2 = _interopRequireDefault(_media);

var _upload_sign = require('./upload_sign');

var _upload_sign2 = _interopRequireDefault(_upload_sign);

var _courier = require('./courier');

var _courier2 = _interopRequireDefault(_courier);

var _package = require('./package');

var _package2 = _interopRequireDefault(_package);

var _refund = require('./refund');

var _refund2 = _interopRequireDefault(_refund);

var _coupon = require('./coupon');

var _coupon2 = _interopRequireDefault(_coupon);

var _home = require('./home');

var _home2 = _interopRequireDefault(_home);

var _resellers = require('./resellers');

var _resellers2 = _interopRequireDefault(_resellers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    order: _order2.default,
    inout: _inout2.default,
    finance: _finance2.default,
    template: _template2.default,
    user: _user2.default,
    level: _level2.default,
    product: _product2.default,
    productType: _product_type2.default,
    nav: _nav2.default,
    auth: _auth2.default,
    captcha: _captcha2.default,
    register: _register2.default,
    pickupStation: _pickup_station2.default,
    shippingTemplate: _shipping_template2.default,
    media: _media2.default,
    uploadSign: _upload_sign2.default,
    courier: _courier2.default,
    package: _package2.default,
    refund: _refund2.default,
    coupon: _coupon2.default,
    home: _home2.default,
    reseller: _resellers2.default,
    routing: _reactRouterRedux.routerReducer
});


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/index.js
// module id = 601
// module chunks = 0